import { Button, Grid } from '@mui/material'
import React from 'react'
import { motion } from "framer-motion"; // Importa o motion para animações
import { useNavigate } from 'react-router-dom';


const Locais = ({ allPlaces, selecionaCategoria }) => {
  const navigate = useNavigate();

  // Filtra os locais pela categoria selecionada
  const locaisFiltrados = allPlaces.filter(
    (item) => item.categoria === selecionaCategoria
  );
// console.log(locaisFiltrados)
  const toCalendario = (localID) => {
    navigate(`/private/agenda/calendario/${localID}`,
    );
  }

  return (
    <>
      <Grid item xs={12} sm={4} sx={{
        padding: '10px', display: 'flex', alignItems: 'center', flexDirection: 'column',
        // justifyContent: selecionaCategoria?.includes('Social') ? 'flex-end' : 'flex-start',
        justifyContent: allPlaces.findIndex(place => place.categoria === selecionaCategoria) % 2 === 0 ? 'flex-start' : 'flex-end'
        //para não depender do nome em específico 
      }}>
        {locaisFiltrados.map((categoria, index) => {
          let locais = [];
          try {
            locais = JSON.parse(categoria.locais);
          } catch (error) {
            console.error("Erro ao parsear locais:", error);
          }

          return locais.map((local) => (
            <motion.div
              key={local.id || `${index}-${local.local}`}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
              style={{ width: '100%' }}
            >
              <Button
                variant="outlined"
                sx={{ display: "block", marginBottom: 2 }}
                fullWidth
                onClick={() => toCalendario(local.id)}
              >
                {local.local}
              </Button>
            </motion.div>
          ));
        })}
      </Grid>
    </>
  )
}

export default Locais
